import { render, staticRenderFns } from "./DropboxDetail.vue?vue&type=template&id=4784f475&scoped=true"
import script from "./DropboxDetail.vue?vue&type=script&lang=js"
export * from "./DropboxDetail.vue?vue&type=script&lang=js"
import style0 from "./DropboxDetail.vue?vue&type=style&index=0&id=4784f475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784f475",
  null
  
)

export default component.exports